__turbopack_context__.v({
  "hitImageContainer": "PTTAsImage-module-scss-module__W3tzSa__hitImageContainer",
  "hitImageLink": "PTTAsImage-module-scss-module__W3tzSa__hitImageLink",
});
